import { useApiRequest } from '@/lib/http-utils'
import { omitNullish } from '@/lib/utils'
import { useQuery } from '@tanstack/react-query'
import { taskManagerApiPaths } from './_paths'

export type AgentRegistryType = 'chat' | 'schedule'

export type ServiceRegistry = {
  id: string
  name: string
  url: string
  service_type: string
  error_description?: string
}

type ServiceRegistryAPIResponse = {
  items: ServiceRegistry[]
  total: number
  page: number
  size: number
  pages: number
}

export type UseServiceRegistrySearchParams = {
  sort_by?: string
  sort_order?: 'asc' | 'desc'
  page?: number
  size?: number
}

export function useServiceRegistryQuery({
  searchParams,
}: {
  searchParams: UseServiceRegistrySearchParams
}) {
  const { apiRequest, domainId } = useApiRequest()
  const urlSearchString = new URLSearchParams(omitNullish(searchParams)).toString()
  return useQuery<ServiceRegistryAPIResponse>({
    queryKey: ['service-registry', domainId, searchParams],
    queryFn: async () => {
      const response = await apiRequest({
        path: `${taskManagerApiPaths.mcpAll({ domainId })}?${urlSearchString}`,
      })
      const json = (await response.json()) as ServiceRegistryAPIResponse

      return json
    },
  })
}
